module.exports = __webpack_public_path__ + "gt.66e9b2eefe5f6b61a229.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/gt.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/gt.svg
// module chunks = styles